<ngb-datepicker #ngbDatepicker [(ngModel)]="model" [minDate]="minDate" (navigate)="date = $event.next" (dateSelect)="dateSelected($event)"></ngb-datepicker>
